<div class="variables-form" *ngIf="variablesForm && scopeNames.length; else notConfigured">
  <form [formGroup]="variablesForm">

    <ng-container *ngFor="let scope of scopeNames">
      <section #tr class="qa-variable" *ngIf="!isDisabledScope(scope)"
        [class.qa-variable-group-start]="variableScopes[scope].hr"
        [class.qa-variable-dirty]="variablesForm.get(scope).dirty"
        [attr.aria-label]="variableScopes[scope]?.name || scope">
        <div class="qa-variable-header">
          <span class="qa-var-scope" [ngbTooltip]="_(variableScopes[scope]?.tooltip)">
            <i *ngIf="variableScopes[scope].icon" class="fa {{variableScopes[scope].icon}}" aria-hidden="true"></i>
            {{variableScopes[scope]?.name || scope}}
          </span>
          <span class="qa-variable-badge-dirty" *ngIf="variablesForm.get(scope).dirty">{{_(KEYS.EDITOR.FORMULA_UNSAVED)}}</span>
          <div class="qa-variable-actions">
            <!-- same actions as the formula rows: apply, undo, delete -->
            <button type="button"
              class="qa-icon-btn qa-icon-btn-save"
              [attr.aria-label]="_(KEYS.EDITOR.SAVE_VARIABLE)"
              (click)="onSave(tr, variablesForm.get(scope), scope)"
              [disabled]="!variablesForm.valid || !variablesForm.get(scope).dirty || !variablesForm.get(scope).value"
            >
              <i aria-hidden="true" class="fa fa-check"></i>
            </button>
            <button type="button"
              class="qa-icon-btn"
              [attr.aria-label]="_(KEYS.EDITOR.RESET_VARIABLE)"
              ngbTooltip="{{_(KEYS.EDITOR.RESET_VARIABLE)}}"
              (click)="onReset(tr, variablesForm.get(scope), scope)"
            >
              <i aria-hidden="true" class="fa fa-undo"></i>
            </button>
            <button type="button"
              [disabled]="variablesForm.get(scope).dirty || !variablesForm.get(scope).value ? true : null"
              class="qa-icon-btn qa-icon-btn-danger"
              [attr.aria-label]="_(KEYS.EDITOR.DELETE_VARIABLE)"
              ngbTooltip="{{_(KEYS.EDITOR.DELETE_VARIABLE)}}" #dt="ngbTooltip"
              (click)="dt.close(); onDelete(tr, variablesForm.get(scope), scope)"
            >
              <i aria-hidden="true" class="fa fa-trash"></i>
            </button>
          </div>
        </div>
        <div class="qa-variable-fields">
          <div class="qa-variable-name">
            <ng-container *ngIf="variableScopes[scope]?.mappings; else freeInput">
              <select
                class="form-control" #variableNameInput [attr.data-variable-scope]="scope"
                [attr.aria-label]="_(KEYS.EDITOR.VARIABLE_NAME) + ' (' + (variableScopes[scope]?.name || scope) + ')'"
                [formControlName]="scope"
                (change)="onDirty(tr)"
              >
                <ng-container *ngFor="let mappedVarName of getObjectKeys(variableScopes[scope].mappings)">
                  <option value="{{variableScopes[scope]?.mappings[mappedVarName]}}">
                    {{_(mappedVarName)}}
                  </option>
                </ng-container>
              </select>
            </ng-container>

            <ng-template #freeInput>
              <input
                class="form-control" #variableNameInput [attr.data-variable-scope]="scope"
                [placeholder]="_(KEYS.EDITOR.VARIABLE_NAME)"
                [class.is-invalid]="!!nameError(scope)"
                [attr.aria-label]="_(KEYS.EDITOR.VARIABLE_NAME) + ' (' + (variableScopes[scope]?.name || scope) + ')'"
                [formControlName]="scope"
                (keydown)="onKeyDown($event, tr, scope)"
                (keyup)="onDirty(tr)"
              >
            </ng-template>
          </div>
          <div class="qa-variable-return" *ngIf="variableScopes[scope]?.allowReturnValue">
            <textarea
              class="form-control"
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="10"
              [formControlName]="scope + '-return-value'"
              placeholder="{{_(KEYS.EDITOR.RETURN_VALUE)}}"
              [attr.aria-label]="_(KEYS.EDITOR.RETURN_VALUE) + ' (' + (variableScopes[scope]?.name || scope) + ')'"
              (keydown)="onKeyDown($event, tr, scope, true)"
              (keyup)="onDirty(tr, variablesForm.get(scope));">
            </textarea>
          </div>
        </div>
        <!-- plain words instead of a tooltip: what is wrong with the name, or what the upload name is for -->
        <p class="qa-variable-msg qa-variable-msg-error" *ngIf="nameError(scope) as error" role="alert">
          <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{error}}
        </p>
        <p class="qa-variable-msg" *ngIf="scope === 'upload' && uploadHelp && !nameError(scope)">
          <i class="fa fa-info-circle" aria-hidden="true"></i> {{_(KEYS.EDITOR.UPLOAD_PREFIX_HELP)}}
        </p>
      </section>
    </ng-container>
  </form>
</div>
<ng-template #notConfigured>
  <div class="variables-form">
    {{_(KEYS.EDITOR.NO_VARIABLES_CONFIGURED)}}
  </div>
</ng-template>
